import styled from "styled-components";
// @ts-ignore -> Convert those types on TS on future.
import buildColor from "@fdr/static-ui/ColorPalette";
import { BuildColorProps } from "./types";

export const ButtonScrollbarWrapper = styled.div<{
  backgroundColor?: BuildColorProps;
}>`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 12px;
  gap: 8px;
  overflow-x: auto;
  background-color: ${({ backgroundColor }) =>
    backgroundColor
      ? buildColor(backgroundColor.color, backgroundColor.variation)
      : buildColor("navy", "D2")};

  button {
    white-space: nowrap;
  }

  button > svg {
    margin-right: 8px;
  }
`;
export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex: 1;
`;

export const ViewAllButton = styled.span`
  color: ${buildColor("grey", "L3")};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 70px;
  margin-left: 8px;
`;
